import { Outlet } from 'react-router-dom'
import { usePortalMfaGate } from '../hooks/usePortalMfaGate'
import MfaEnrollmentPrompt from './MfaEnrollmentPrompt'
import PostLoginLoadingScreen from './PostLoginLoadingScreen'

/**
 * Blocks policy detail, claims, and payment routes until MFA is satisfied for linked users.
 */
export default function RequireMfa() {
  const { loading, mfaRequiredForDetail } = usePortalMfaGate()

  if (loading) {
    return <PostLoginLoadingScreen />
  }

  if (mfaRequiredForDetail) {
    return <MfaEnrollmentPrompt />
  }

  return <Outlet />
}
